export const SnackbarVariants = {
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
  INFO: 'info',
};

export const SnackbarDuration = 4000;